import './styles/index.scss';
import Main from './pages/Main';

function App() {
  console.log("App version: 29.05.2026") //version

  const urlMode = new URLSearchParams(window.location.search).get('mode');
  if (urlMode === 'qr') localStorage.setItem('kiosk_mode', 'qr');
  if (urlMode === 'normal') localStorage.removeItem('kiosk_mode');
  const isQrMode = localStorage.getItem('kiosk_mode') === 'qr';

  return (
    <div className="App">
      <Main isQrMode={isQrMode}/>
    </div>
  );
}

export default App;
